import { useState } from 'react';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
import AddJeSource from './AddJeSource';
import EditJeSource from './EditJeSource';
import useGetGlJeSourceList from '../../../../hooks/Finance/useGetGlJeSourceList';
import { Link } from 'react-router-dom';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';

const Index = () => {
  const [ID, setID] = useState<string>('');

  const { t } = useTranslation();

  const { GlJeSourceList, loading, error } = useGetGlJeSourceList();

  const columns = [
    { title: t('LocalName'), key: 'Name2' },
    { title: t('GlobalName'), key: 'Name' },

    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = GlJeSourceList?.map((item) => {
    let rowClass;

    return {
      Name2: item.name2,
      Name: item.name,

      action: (
        <button
          type="button"
          className="btn btn-sm btn-outline-theme"
          data-bs-toggle="modal"
          data-bs-target="#modalEditDailyRates"
          onClick={() => setID(item.id)}>
          <i className="far fa-lg fa-fw fa-edit me-1"></i>
          {t('Button.Edit')}
        </button>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'JeSource',
      link: null,
    },
  ];

  return (
    <div>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="JeSource" />

        <div className="ms-auto">
          <Link
            to=""
            className="btn  btn-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalAddDailyRates">
            <i className="fa fa-plus-circle fa-fw me-1"></i>
            {t('AddJeSource')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddJeSource')} id="modalAddDailyRates" size="sm">
        <AddJeSource />
      </ModalComponent>

      <ModalComponent title={t('EditJeSource')} id="modalEditDailyRates" size="sm">
        {ID && <EditJeSource ID={ID} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
